import Api from '@/shared/services/Api'


export default 
{

	getEstadisticas() {
		return Api().get('setting-get-estadisticas')
	},

	get() {
		return Api().get('setting-get')
	},

	update(data) {
		return Api().post('setting-update', data)
	}

}